<template>
  <div>
    <GlobalInfoBar>
      核销记录列表
    </GlobalInfoBar>
    <GlobalChunk :padding="[20, 20, 20, 20]">

      <GlobalForm :form-item-list="formItemList" :inline="true" round @handleConfirm="query" confirmBtnName="查询"
        @handleChange="searchChange" ref="searchForm">
        <div slot="AddBtn">
          <el-button size="small" type="primary" @click="clearAllSearch()" round>清空</el-button>
        </div>
      </GlobalForm>

      <div style="width: 100%;display: flex;justify-content: end;padding: 15px;">
        <el-button type="success" @click="download()" :loading="downloading">导出</el-button>
      </div>
      <GlobalTable ref="GlobalTable" :columns="tableColumns" :data="tableData" :currentPage="curPage" :total="total"
        @handleCurrentChange="currentChange">
      </GlobalTable>
    </GlobalChunk>


  </div>
</template>

<script>


import {
  writeList, storeDrop, shopDrop, writeListDownload, writeTypeDrop
} from "@/utils/request/membershipSystem";

export default {
  name: "list",
  data() {
    return {
      formItemList: [
        {
          key: 'card_number',
          type: 'input',
          labelName: '会员号：',
          placeholder: '请输入会员号'
        },
        {
          key: 'name',
          type: 'input',
          labelName: '会员名称:',
          placeholder: '请输入会员名称'
        },
        {
          key: 'phone',
          type: 'input',
          labelName: '会员手机号:',
          placeholder: '请输入会员手机号'
        },
        {
          key: 'time',
          type: 'daterange',
          labelName: '时间:',
        },
        {
          key: 'store_id',
          idKey: 'store_id',
          labelKey: 'store_name',
          type: 'selectFilterable',
          labelName: '所属门店商:',
          option: [],
          placeholder: '请选择所属门店商'
        },
        {
          key: 'shop_id',
          idKey: 'shop_id',
          labelKey: 'shop_name',
          type: 'selectFilterable',
          labelName: '所属门店:',
          option: [],
          readonly: true,
          placeholder: '请选择所属门店'
        },
        {
          key: 'staff_name',
          type: 'input',
          labelName: '店员名称:',
          placeholder: '请输入店员名称'
        },
        {
          key: 'staff_phone',
          type: 'input',
          labelName: '店员手机号:',
          placeholder: '请输入店员手机号'
        },
        {
          key: 'type_title',
          idKey: 'title',
          labelKey: 'title',
          type: 'selectFilterable',
          labelName: '核销类型：',
          option: [],
          placeholder: '请选择核销类型'
        },
        {
          key: 'imei',
          type: 'input',
          labelName: '购机串号:',
          placeholder: '请输入购机串号'
        },
      ],
      tableColumns: [
        { label: "会员卡号", prop: "card_number" },
        { label: "核销类型", prop: "type_title" },
        { label: "核销金额", prop: "money" },
        { label: "购机串号", prop: "imei" },
        { label: "会员名称", prop: "name" },
        { label: "会员手机号", prop: "phone" },
        { label: "所属门店商", prop: "store_name" },
        { label: "核销门店", prop: "shop_name" },
        { label: "核销店员名称", prop: "staff_name" },
        { label: "店员手机号", prop: "staff_phone" },
        { label: "核销时间", prop: "add_time" },
        { label: "核销后余额", prop: "after_money" },
        { label: "备注", prop: "notes" },
      ],
      tableData: [],
      curPage: 1,
      total: 0,
      searchData: {},
      downloading: false

    }
  },
  mounted() {
    const { card_number } = this.$route.query;
    this.searchData.card_number = card_number
    this.$refs.searchForm.formData.card_number = card_number
    this.writeList()
    this.storeDrop()
    this.writeTypeDrop()
  },
  watch: {
    searchData(val) {
      console.log('val', val);

    },
  },

  methods: {
    storeDrop() {
      storeDrop().then(res => {
        this.formItemList[4].option = res.data || []
      })
    },
    writeTypeDrop() {
      writeTypeDrop().then(res => {
        this.formItemList[8].option = res.data || []
      })
    },
    writeList() {
      writeList({
        page: this.curPage,
        ...this.searchData
      }).then(res => {
        this.tableData = res.data || []
        this.total = res.count || 0
      })
    },
    currentChange(page) {
      this.curPage = page
      this.writeList()
    },
    searchChange(item, value) {
      console.log(item, value);
      if (item.idKey == 'store_id' && value == '') {
        this.formItemList[5].option = []
        this.searchData.shop_id = null
        this.formItemList[5].readonly = true
      } else if (item.idKey == 'store_id') {
        this.formItemList[5].readonly = false
        shopDrop({
          store_id: value
        }).then(res => {
          this.formItemList[5].option = res.data || []
        })
      }

    },
    query(val) {
      console.log(val);
      const { time } = val
      this.searchData = {
        beg_time: time ? Date.parse(time[0]) : '',
        end_time: time ? Date.parse(time[1]) : '',
        ...val
      }
      this.writeList()
    },
    clearAllSearch() {
      this.$refs.searchForm.clear()
      this.searchData = {}
      this.curPage = 1,
        this.writeList()
    },
    download() {
      const { time } = this.$refs.searchForm.formData
      const DownLoadSearch = {
        beg_time: time ? Date.parse(time[0]) : '',
        end_time: time ? Date.parse(time[1]) : '',
        ...this.$refs.searchForm.formData
      }
      this.downloading = true
      writeListDownload(DownLoadSearch).then((res) => {
        this.downloading = false
        const content = res;
        const blob = new Blob([content]);
        const fileName = "核销记录列表.xls";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
  }
}
</script>

<style scoped lang="scss"></style>